import { GOLDSMITH_ACTION_TYPES } from '../actions/goldsmithActions';

const initialState = {
  // Goldsmith state
  goldsmiths: [],
  currentGoldsmith: null,
  goldsmithsLoading: false,
  goldsmithsError: null,
  
  // Customer Orders state
  customerOrders: [],
  currentOrder: null,
  selectedOrder: null,
  ordersLoading: false,
  ordersError: null,
  
  // Purchases state
  purchases: [],
  currentPurchase: null,
  purchasesLoading: false,
  purchasesError: null,
  
  // Gold Rate state
  goldRate: 0,
  goldRateLoading: false,
  goldRateError: null,
  
  // Account state
  accountSummary: null,
  accountLoading: false,
  accountError: null
};

const goldsmithReducer = (state = initialState, action) => {
  switch (action.type) {
    // Goldsmith Actions
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITHS_REQUEST:
      return {
        ...state,
        goldsmithsLoading: true,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITHS_SUCCESS:
      return {
        ...state,
        goldsmiths: action.payload.data,
        goldsmithsLoading: false,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITHS_FAILURE:
      return {
        ...state,
        goldsmithsLoading: false,
        goldsmithsError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_BY_ID_REQUEST:
      return {
        ...state,
        goldsmithsLoading: true,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_BY_ID_SUCCESS:
      return {
        ...state,
        currentGoldsmith: action.payload.data,
        goldsmithsLoading: false,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_BY_ID_FAILURE:
      return {
        ...state,
        goldsmithsLoading: false,
        goldsmithsError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.CREATE_GOLDSMITH_REQUEST:
      return {
        ...state,
        goldsmithsLoading: true,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.CREATE_GOLDSMITH_SUCCESS:
      return {
        ...state,
        goldsmiths: [action.payload.data, ...state.goldsmiths],
        goldsmithsLoading: false,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.CREATE_GOLDSMITH_FAILURE:
      return {
        ...state,
        goldsmithsLoading: false,
        goldsmithsError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.UPDATE_GOLDSMITH_REQUEST:
      return {
        ...state,
        goldsmithsLoading: true,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.UPDATE_GOLDSMITH_SUCCESS:
      return {
        ...state,
        goldsmiths: state.goldsmiths.map(goldsmith =>
          goldsmith.id === action.payload.data.id ? action.payload.data : goldsmith
        ),
        currentGoldsmith: action.payload.data,
        goldsmithsLoading: false,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.UPDATE_GOLDSMITH_FAILURE:
      return {
        ...state,
        goldsmithsLoading: false,
        goldsmithsError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.DELETE_GOLDSMITH_REQUEST:
      return {
        ...state,
        goldsmithsLoading: true,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.DELETE_GOLDSMITH_SUCCESS:
      return {
        ...state,
        goldsmiths: state.goldsmiths.filter(goldsmith => goldsmith.id !== action.payload),
        goldsmithsLoading: false,
        goldsmithsError: null
      };
    case GOLDSMITH_ACTION_TYPES.DELETE_GOLDSMITH_FAILURE:
      return {
        ...state,
        goldsmithsLoading: false,
        goldsmithsError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_ACCOUNT_REQUEST:
      return {
        ...state,
        accountLoading: true,
        accountError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_ACCOUNT_SUCCESS:
      return {
        ...state,
        accountSummary: action.payload.data,
        accountLoading: false,
        accountError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLDSMITH_ACCOUNT_FAILURE:
      return {
        ...state,
        accountLoading: false,
        accountError: action.payload
      };

    // Customer Order Actions
    case GOLDSMITH_ACTION_TYPES.GET_CUSTOMER_ORDERS_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_CUSTOMER_ORDERS_SUCCESS:
      return {
        ...state,
        customerOrders: action.payload.data,
        ordersLoading: false,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_CUSTOMER_ORDERS_FAILURE:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        currentOrder: action.payload.data,
        selectedOrder: action.payload.data,
        ordersLoading: false,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_ORDER_BY_ID_FAILURE:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.CREATE_CUSTOMER_ORDER_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.CREATE_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        customerOrders: [action.payload.data, ...state.customerOrders],
        ordersLoading: false,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.CREATE_CUSTOMER_ORDER_FAILURE:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.UPDATE_CUSTOMER_ORDER_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.UPDATE_CUSTOMER_ORDER_SUCCESS:
      return {
        ...state,
        customerOrders: state.customerOrders.map(order =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        currentOrder: action.payload.data,
        ordersLoading: false,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.UPDATE_CUSTOMER_ORDER_FAILURE:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.ASSIGN_GOLDSMITH_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.ASSIGN_GOLDSMITH_SUCCESS:
      return {
        ...state,
        customerOrders: state.customerOrders.map(order =>
          order.id === action.payload.data.id ? action.payload.data : order
        ),
        currentOrder: action.payload.data,
        ordersLoading: false,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.ASSIGN_GOLDSMITH_FAILURE:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.ADD_ORDER_PAYMENT_REQUEST:
      return {
        ...state,
        ordersLoading: true,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.ADD_ORDER_PAYMENT_SUCCESS:
      return {
        ...state,
        ordersLoading: false,
        ordersError: null
      };
    case GOLDSMITH_ACTION_TYPES.ADD_ORDER_PAYMENT_FAILURE:
      return {
        ...state,
        ordersLoading: false,
        ordersError: action.payload
      };

    // Purchase Actions
    case GOLDSMITH_ACTION_TYPES.GET_PURCHASES_REQUEST:
      return {
        ...state,
        purchasesLoading: true,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_PURCHASES_SUCCESS:
      return {
        ...state,
        purchases: action.payload.data,
        purchasesLoading: false,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_PURCHASES_FAILURE:
      return {
        ...state,
        purchasesLoading: false,
        purchasesError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.GET_PURCHASE_BY_ID_REQUEST:
      return {
        ...state,
        purchasesLoading: true,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_PURCHASE_BY_ID_SUCCESS:
      return {
        ...state,
        currentPurchase: action.payload.data,
        purchasesLoading: false,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_PURCHASE_BY_ID_FAILURE:
      return {
        ...state,
        purchasesLoading: false,
        purchasesError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.CREATE_PURCHASE_REQUEST:
      return {
        ...state,
        purchasesLoading: true,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.CREATE_PURCHASE_SUCCESS:
      return {
        ...state,
        purchases: [action.payload.data, ...state.purchases],
        purchasesLoading: false,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.CREATE_PURCHASE_FAILURE:
      return {
        ...state,
        purchasesLoading: false,
        purchasesError: action.payload
      };

    case GOLDSMITH_ACTION_TYPES.UPDATE_PURCHASE_REQUEST:
      return {
        ...state,
        purchasesLoading: true,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.UPDATE_PURCHASE_SUCCESS:
      return {
        ...state,
        purchases: state.purchases.map(purchase =>
          purchase.id === action.payload.data.id ? action.payload.data : purchase
        ),
        currentPurchase: action.payload.data,
        purchasesLoading: false,
        purchasesError: null
      };
    case GOLDSMITH_ACTION_TYPES.UPDATE_PURCHASE_FAILURE:
      return {
        ...state,
        purchasesLoading: false,
        purchasesError: action.payload
      };

    // Gold Rate Actions
    case GOLDSMITH_ACTION_TYPES.GET_GOLD_RATE_REQUEST:
      return {
        ...state,
        goldRateLoading: true,
        goldRateError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLD_RATE_SUCCESS:
      return {
        ...state,
        goldRate: action.payload.data.gold_rate,
        goldRateLoading: false,
        goldRateError: null
      };
    case GOLDSMITH_ACTION_TYPES.GET_GOLD_RATE_FAILURE:
      return {
        ...state,
        goldRateLoading: false,
        goldRateError: action.payload
      };

    default:
      return state;
  }
};

export default goldsmithReducer;
